// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c9e46892","79":"3bacc6e5","243":"50287c85","259":"fd682364","288":"e7f85c22","426":"99e7dba5","915":"c927e6e3"}[chunkId] + ".chunk.css";
};